var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumanSafety(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M58.3333 48.2344C58.3333 50.6406 57.677 52.9375 56.4739 54.9062C56.0364 55.5625 55.5989 56.2188 55.1614 56.7656C54.0676 58.0781 52.7551 59.0625 51.2239 59.8281C50.5676 60.1562 49.9114 60.4844 49.1458 60.7031C47.9426 61.1406 46.6301 61.3594 45.2083 61.3594C37.9895 61.3594 32.0833 55.4531 32.0833 48.2344C32.0833 46.8125 32.302 45.5 32.7395 44.1875C32.9583 43.4219 33.2864 42.7656 33.6145 42.1094C35.802 37.9531 40.177 35 45.3176 35C52.427 35.1094 58.3333 41.0156 58.3333 48.2344Z",
    fill: "#67E48B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.657 23.334C54.6603 20.8578 54.669 18.5883 54.6876 16.7978C54.6975 15.8834 54.2468 15.0248 53.5042 14.4911C52.7615 13.9573 51.8067 13.8151 50.9404 14.1072",
    stroke: "#222A33",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6658 14.4725C50.6658 14.4725 50.6658 14.4725 50.6658 14.4725",
    stroke: "#222A33",
    strokeWidth: 0.03125,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0863 13.8895C27.86 15.4744 23.3384 15.552 19.063 14.1083C19.0619 14.1083 19.0608 14.1083 19.0597 14.1072C18.1934 13.8152 17.2386 13.9573 16.4959 14.4911C15.7533 15.0248 15.3125 15.8834 15.3125 16.7978C15.3125 21.8509 15.3125 30.7256 15.3125 37.2695",
    stroke: "#222A33",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4038 57.1397C34.4038 57.1397 41.5372 53.0403 47.3429 49.7033",
    stroke: "#222A33",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0625 16.3056C59.0625 14.1312 58.0147 12.0903 56.2483 10.8226C54.4819 9.55388 52.2134 9.21482 50.1528 9.90935C50.1517 9.91044 50.1506 9.91044 50.1506 9.91044C46.5927 11.1114 42.7306 11.0468 39.2142 9.72888C37.6075 9.12622 36.3453 8.65263 36.3453 8.65263C35.478 8.32779 34.522 8.32779 33.6547 8.65263C33.6547 8.65263 32.3925 9.12622 30.7858 9.72888C27.2694 11.0468 23.4073 11.1114 19.8494 9.91044C19.8494 9.91044 19.8483 9.91044 19.8472 9.90935C17.7866 9.21482 15.5181 9.55388 13.7517 10.8226C11.9853 12.0903 10.9375 14.1312 10.9375 16.3056C10.9375 21.4987 10.9375 30.6173 10.9375 37.3406C10.9375 43.9184 14.362 50.0215 19.9752 53.4493C25.5719 56.8673 32.3892 61.029 32.3892 61.029C33.5847 61.7597 35.0831 61.7793 36.2972 61.0815C36.2972 61.0815 43.6264 56.8695 49.5928 53.4406C55.4509 50.074 59.0625 43.8331 59.0625 37.0759V16.3056V16.3056Z",
    stroke: "#222A33",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33.9062C38.0203 33.9062 40.4688 31.4578 40.4688 28.4375C40.4688 25.4172 38.0203 22.9688 35 22.9688C31.9797 22.9688 29.5312 25.4172 29.5312 28.4375C29.5312 31.4578 31.9797 33.9062 35 33.9062Z",
    stroke: "#91F3AE",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1536 44.2969C25.8562 39.9809 30.159 37.1875 35 37.1875C39.8409 37.1875 44.1437 39.9809 46.8464 44.2969",
    stroke: "#91F3AE",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanSafety);
export default __webpack_public_path__ + "static/media/HumanSafety.5d60e749bc473b0a638e52f4061e3d74.svg";
export { ForwardRef as ReactComponent };